import React from 'react';
import { Nodejs, Python } from '@dragonchain-dev/dragon-kit-icons';
import { LinkTo } from '../LinkTo';

var SdkPanel = function SdkPanel() {
  return /*#__PURE__*/React.createElement("div", {
    className: "sdks"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sdk"
  }, /*#__PURE__*/React.createElement(LinkTo, {
    blank: true,
    type: "link",
    url: "https://www.npmjs.com/package/dragonchain-sdk"
  }, /*#__PURE__*/React.createElement(Nodejs, null))), /*#__PURE__*/React.createElement("div", {
    className: "sdk"
  }, /*#__PURE__*/React.createElement(LinkTo, {
    blank: true,
    type: "link",
    url: "https://pypi.org/project/dragonchain-sdk"
  }, /*#__PURE__*/React.createElement(Python, {
    size: "xlarge"
  }))));
};

SdkPanel.displayName = 'SdkPanel';
var SdkPanelDoc;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  SdkPanelDoc = require('./doc').doc(SdkPanel);
}

var SdkPanelWrapper = SdkPanelDoc || SdkPanel;
export { SdkPanelWrapper as SdkPanel };